// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__30BAq","tab":"ProcedureTabs_tab__3h6Y_"};